import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const openStackService = {
  getOpenStackSettings:() => ApiClient.get(`settings/openstack`),
  saveOpenStackSettings:(data:any) => ApiClient.post(`settings/openstack`, data),
  testConnection:(data:any) => ApiClient.post(`settings/openstack/test_connection`, data),
  getOpenRcFile:(data:any) => ApiClient.post(`users/get_openrc_file_content`, data),

  getDefaultsSettings:() => ApiClient.get(`settings/openstack/defaults`),
  updateDefaultsSettings:(data:any) => ApiClient.post(`settings/openstack/defaults`,data),

  getRegionSettings:() => ApiClient.get(`openstack/regions/all_regions`),
  updateRegionSettings:(data:any) => ApiClient.post(`openstack/regions/update_regions`,data),

  getNotificationSettings:() => ApiClient.get(`settings/openstack/notifications`),
  updateNotificationSettings:(data:any) => ApiClient.post(`settings/openstack/notifications`,data),


  getOpenstackPlans:(queries:QueriesApi) => ApiClient.get(`openstack/billing/plan`,{
    params:{
      ...queries,
    }
  }),
}

export default openStackService
